import script from "./BookingPlaceholder.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingPlaceholder.vue?vue&type=script&lang=ts&setup=true"

import "./BookingPlaceholder.vue?vue&type=style&index=0&id=30fa9556&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30fa9556"]])

export default __exports__